import script from "./DeckRegions.vue?vue&type=script&setup=true&lang=js"
export * from "./DeckRegions.vue?vue&type=script&setup=true&lang=js"

import "./DeckRegions.vue?vue&type=style&index=0&id=b4e616d6&scoped=true&lang=css"

import exportComponent from "F:\\Projects\\Code\\2021 09 29 LMT\\LoR_Master\\UI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4e616d6"]])

export default __exports__